module.exports = __webpack_public_path__ + "static/img/9b.a9f6d66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/9b.jpg
// module id = DAja
// module chunks = 0